/**
 * Inicializacao do Sentry no browser.
 *
 * Importado como primeira linha de `main.tsx` para que erros de carregamento
 * dos proprios modulos da aplicacao ja sejam capturados.
 *
 * O DSN e assado no bundle em tempo de build (VITE_SENTRY_DSN), igual a
 * VITE_API_URL. Isso e esperado: DSN de frontend e publico por design, ele so
 * permite ENVIAR evento para o projeto, nunca ler. Como o builder do OpenShip
 * descarta a secao `args:` do compose, o valor vive no ARG do
 * `frontend/docker/Dockerfile.openship`.
 *
 * Sem DSN o `init` nao roda e a aplicacao segue normalmente.
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

        integrations: [
            // Mede carregamento de pagina e navegacao entre rotas, e registra
            // cada chamada de fetch como breadcrumb — e assim que se ve o que o
            // usuario fez ANTES do erro.
            Sentry.browserTracingIntegration(),
        ],

        // 10% das navegacoes. Erro e sempre 100%, independente deste valor.
        tracesSampleRate: 0.1,

        // `tracePropagationTargets` fica DE FORA de proposito. Sem essa opcao o
        // SDK so anexa os headers `sentry-trace`/`baggage` a requisicoes de
        // mesma origem (ver shouldAttachHeaders no @sentry/browser), e a API
        // esta em outro dominio. Ou seja: nenhuma chamada para a API ganha
        // header novo, e o CORS do backend nao precisa mudar.
        //
        // O custo e que o trace do front nao se conecta ao do backend. Para
        // ligar os dois depois, adicione o dominio da API aqui E inclua
        // 'sentry-trace' e 'baggage' em allowedHeaders no enableCors de
        // backend/src/main.ts — nessa ordem, senao o preflight quebra.

        // Nao envia IP nem dados de formulario automaticamente. O usuario e
        // anexado explicitamente pelo AuthContext apos o login.
        sendDefaultPii: false,

        // Ruido que nao e bug da aplicacao: extensao de navegador, tradutor
        // automatico do Chrome e falha de rede do proprio usuario.
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            // Fluxos de sessao tratados pela UI, nao sao falha (ver services/api.ts)
            'SESSION_EXPIRED',
            'ACCOUNT_SUSPENDED',
        ],
        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i,
            /^moz-extension:\/\//i,
        ],
    });
}
